// extracted by mini-css-extract-plugin
export default {"wrap":"NoData_wrap--iqJ","img":"NoData_img--DLa","text":"NoData_text--v2m"};